import React from 'react';
import { Card, CardContent, Box, Typography, Chip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

/**
 * PresetCard Component
 *
 * Displays a theme preset with color palette preview
 * and selection state
 */
const PresetCard = ({ preset, isSelected, onClick }) => {
  return (
    <Card
      onClick={onClick}
      sx={{
        cursor: 'pointer',
        border: isSelected ? '3px solid' : '1px solid',
        borderColor: isSelected ? 'primary.main' : 'divider',
        transition: 'all 0.2s ease-in-out',
        position: 'relative',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        '&:hover': {
          boxShadow: 6,
          transform: 'translateY(-2px)',
        },
      }}
    >
      {/* Color Palette Preview */}
      <Box sx={{ display: 'flex', height: 80 }}>
        <Box
          sx={{
            flex: 1,
            bgcolor: preset.primary_color,
            transition: 'flex 0.3s ease',
            '&:hover': {
              flex: 1.5,
            },
          }}
          title={`Primary: ${preset.primary_color}`}
        />
        <Box
          sx={{
            flex: 1,
            bgcolor: preset.secondary_color,
            transition: 'flex 0.3s ease',
            '&:hover': {
              flex: 1.5,
            },
          }}
          title={`Secondary: ${preset.secondary_color}`}
        />
        <Box
          sx={{
            flex: 1,
            bgcolor: preset.accent_color,
            transition: 'flex 0.3s ease',
            '&:hover': {
              flex: 1.5,
            },
          }}
          title={`Accent: ${preset.accent_color}`}
        />
      </Box>

      {/* Selected Indicator */}
      {isSelected && (
        <Box
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            bgcolor: 'background.paper',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CheckCircleIcon color="primary" sx={{ fontSize: 32 }} />
        </Box>
      )}

      <CardContent
        sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}
      >
        <Typography variant="h6" gutterBottom sx={{ minHeight: 32 }}>
          {preset.theme_name}
        </Typography>

        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            mb: 1.5,
            flexGrow: 1,
            minHeight: 60,
            display: '-webkit-box',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
          }}
        >
          {preset.theme_description}
        </Typography>

        {preset.vibe && (
          <Box>
            <Chip
              label={preset.vibe}
              size="small"
              color={isSelected ? 'primary' : 'default'}
              sx={{ fontWeight: 500 }}
            />
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default PresetCard;
